import { createAsyncThunk } from '@reduxjs/toolkit';

import request from '../../modules/Request/request';

export const getAllAccountStats = createAsyncThunk(
  'getAllAccountStats',
  async (object, { rejectWithValue }) => {
    const response = await request('/accounts-stats', { method: 'GET' });
    if (response.success) {
      return { data: response.data, object };
    }
    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);
